<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="data-list-list-view" class="data-list-container">
		<vs-table
			id="div-with-loading"
			ref="table"
			:multiple="customConfig.multiple"
			v-model="selected"
			pagination
			:max-items="itemsPerPage"
			search
			:data="listDepots"
		>
			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
				<div class="flex flex-wrap-reverse items-center data-list-btn-container">
					<div
						v-if="depotCreatePermission && customConfig.btnAssign"
						@click="assignHandle"
						class="btn-add-new p-3 mb-3 mt-3 ml-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
					>
						<feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
						<span class="ml-2 text-base text-primary">{{ "Asignar" }}</span>
					</div>
					<vs-button
						v-if="depotCreatePermission && customConfig.btnAdd"
						class="mr-2"
						color="primary"
						icon-pack="feather"
						icon="icon-plus"
						:title="$t('Deposits.AddDeposit')"
						@click.prevent="addNewData"
						>{{ $t("Deposits.AddDeposit") | capitalize }}
					</vs-button>
					<vs-button
						v-else
						class="mr-2"
						color="primary"
						icon-pack="feather"
						icon="icon-plus"
						@click.prevent="assignHandle"
						>{{ ($t("VisitPoints.Assig") + " " + $t("Routing.Title.Selection")) | capitalize }}
					</vs-button>
				</div>
				<!-- ITEMS PER PAGE -->
				<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
					<div
						class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
					>
						<span class="mr-2"
							>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }}
							-
							{{
								listDepots.length - currentPage * itemsPerPage > 0
									? currentPage * itemsPerPage
									: listDepots.length
							}}
							{{ $t("Of") }} {{ queriedItems }}</span
						>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
					</div>
					<vs-dropdown-menu>
						<vs-dropdown-item @click="itemsPerPage = 4">
							<span>4</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage = 10">
							<span>10</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage = 15">
							<span>15</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage = 20">
							<span>20</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
			<template slot="thead">
				<vs-th v-show="customConfig.showColumns.id" sort-key="id">{{ "ID" }}</vs-th>
				<vs-th v-show="customConfig.showColumns.name" sort-key="name">{{ $t("Deposits.Table.Name") }}</vs-th>
				<vs-th v-show="customConfig.showColumns.description" sort-key="description">{{
					$t("Deposits.Table.Description")
				}}</vs-th>
				<vs-th v-show="customConfig.showColumns.address" sort-key="address">{{
					$t("Deposits.Table.Address")
				}}</vs-th>
				<vs-th v-show="customConfig.showColumns.city" sort-key="city">{{ $t("Deposits.Table.City") }}</vs-th>
				<vs-th v-if="customConfig.showColumns.action">{{ $t("Deposits.Table.Action") }}</vs-th>
			</template>
			<template slot-scope="{data}">
				<tbody>
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td v-show="customConfig.showColumns.name">
							<p class="product-name font-medium truncate capitalize">
								{{ tr.id }}
							</p>
						</vs-td>
						<vs-td v-show="customConfig.showColumns.name">
							<p class="product-name font-medium truncate capitalize">
								{{ tr.name }}
							</p>
						</vs-td>
						<vs-td v-show="customConfig.showColumns.description">
							<p class="product-category normal-case">
								{{ tr.description }}
							</p>
						</vs-td>
						<vs-td v-show="customConfig.showColumns.address">
							<p class="product-category normal-case">
								{{ tr.address }}
							</p>
						</vs-td>
						<vs-td v-show="customConfig.showColumns.city">
							<p class="product-category capitalize">
								{{ tr.city }}
							</p>
						</vs-td>
						<vs-td class="whitespace-no-wrap" v-if="customConfig.showColumns.action">
							<feather-icon
								v-if="depotUpdatePermission"
								icon="EditIcon"
								svgClasses="w-5 h-5 hover:text-primary stroke-current"
								@click.stop="editData(tr)"
							/>
							<feather-icon
								v-if="depotDeletePermission"
								icon="Trash2Icon"
								svgClasses="w-5 h-5 hover:text-danger stroke-current"
								class="ml-2"
								@click.stop="openConfirm(tr.id)"
							/>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>

<script>
import moduleDepot from "@/store/depot/moduleDepot.js";

export default {
	name: "TeamsListView",
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					btnAdd: true,
					showColumns: {
						id: true,
						name: true,
						description: true,
						address: true,
						city: true,
						action: true,
					},
					multiple: false,
				};
			},
		},
	},
	data() {
		return {
			selected: [],
			itemsPerPage: 10,
			isMounted: false,
			itemSelected: null,
		};
	},
	computed: {
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx;
			}
			return 0;
		},
		listDepots() {
			let listDepots = this.$store.state.moduleDepot.depots;
			listDepots = listDepots.reverse();
			return listDepots;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.listDepots.length;
		},
		depotUpdatePermission() {
			return this.$store.getters.checkPermission("DEPOSITS_U");
		},
		depotDeletePermission() {
			return this.$store.getters.checkPermission("DEPOSITS_D");
		},
		depotCreatePermission() {
			return this.$store.getters.checkPermission("DEPOSITS_C");
		},
	},
	methods: {
		addNewData() {
			this.$router.push("/dashboard/new-deposit");
		},
		openConfirm(id) {
			this.itemSelected = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Deposits.Messages.TextDelete"),
				accept: this.acceptAlert,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		acceptAlert() {
			this.deleteData(this.itemSelected);
		},
		deleteData(id) {
			this.$store
				.dispatch("moduleDepot/removeItem", id)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Deposits.Messages.TitleConfirmDelete"),
						text: this.$t("Deposits.Messages.TextConfirmDelete"),
					});
				})
				.catch((err) => {
					console.error(err);
				});
		},
		editData(data) {
			this.$router.push("/dashboard/update-deposit/" + data.id);
		},
		assignHandle() {
			this.$emit("getInfoDepot", this.selected);
			this.$emit("closePopup", true);
		},
	},
	created() {
		if (!moduleDepot.isRegistered) {
			this.$store.registerModule("moduleDepot", moduleDepot);
			moduleDepot.isRegistered = true;
		}
		this.$store.dispatch("moduleDepot/fetchDataListItems").then(() => {
			this.$vs.loading.close("#div-with-loading > .con-vs-loading");
		});
	},
	mounted() {
		this.isMounted = true;
		this.$vs.loading({
			container: "#div-with-loading",
			scale: 1,
			type: "sound",
		});
	},
};
</script>
